import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("iFlJw"), parcelRequire.load("8Jf43"), parcelRequire.load("k5MRs"), parcelRequire.load("9DQq0")]).then(() => {
  return Promise.all([waitForCSS("/reactspectrum/60911cde55ae4daa9375c5df6296a6d93bc1093b/s2-docs/pages.9cb5e405.css")]);
}).then(() => {
let originalModule = parcelRequire("jFoC3");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("iFlJw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8Jf43")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("k5MRs")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9DQq0")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
